import React from 'react';
import { Box, Form, TextButton, useMediaQuery, Modal } from 'bonfire-kindling';
import { ModalTitle, RecaptchaField } from 'components';
import { useTranslation } from 'react-i18next';
import useChangeEmail from './hooks/useChangeEmail';
import { isEmailValid } from 'helpers/validation';

const EditEmailModal = ({ onClose, open, currentEmail }) => {
  const isMobileWidth = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const { t } = useTranslation();
  const [{ isSuccess }, changeEmail] = useChangeEmail();

  React.useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess, onClose]);

  const onSubmit = values => {
    let errors = {};
    if (values.newEmail && !isEmailValid(values.newEmail)) {
      errors.newEmail = t('settings.change_email.invalid_email');
    }
    if (currentEmail === values.newEmail) {
      errors.newEmail = t('settings.change_email.must_be_different');
    }
    if (!values.recaptchaToken) {
      errors.recaptchaToken = t('settings.change_password.recaptcha_required');
    }
    if (Object.keys(errors).length > 0) {
      return errors;
    }
    changeEmail(values);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="email-change-modal-title"
      size={isMobileWidth ? 'tiny' : 'medium'}
    >
      <ModalTitle onClose={onClose} id="email-change-modal-title">
        {t('settings.change_email.title')}
      </ModalTitle>
      <Form onSubmit={onSubmit}>
        {({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit}>
            <Box
              padding={isMobileWidth ? '0 1rem' : '0 2rem'}
              display="flex"
              alignItems={isMobileWidth ? 'center' : 'flex-start'}
              flexDirection="column"
            >
              <Form.TextField
                name="currentEmail"
                label={t('settings.change_email.current')}
                value={currentEmail}
                disabled
                fullWidth
              />
              <Form.TextField
                name="newEmail"
                label={t('settings.change_email.enter')}
                required
                fullWidth
              />
              <Form.TextField
                name="password"
                label={t('settings.account.password')}
                type="password"
                required
                data-cy="editEmailPassword"
                fullWidth
              />
              <Form.Field name="recaptchaToken" component={RecaptchaField} />
            </Box>
            <Box
              display="flex"
              padding={isMobileWidth ? '1rem 1rem' : '1rem 2rem'}
              justifyContent="end"
            >
              <TextButton
                variant="contained"
                color="primary"
                type="submit"
                isLoading={submitting}
                label={t('settings.change_email.change')}
                sx={{ marginRight: '1rem' }}
              />
              <TextButton
                variant="outlined"
                onClick={onClose}
                disabled={submitting}
                label={t('settings.change_email.cancel')}
              />
            </Box>
          </form>
        )}
      </Form>
    </Modal>
  );
};

export default EditEmailModal;
